import { useState } from 'react';
import { Api } from '../../../services/api';

export const NewUser = () => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const [input, setInput] = useState({
    nick: '',
    pass: '',
    nome: '',
    admin: false,
  });

  const [error, setError] = useState({
    nick: false,
    pass: false,
    nome: false,
    message: '',
  });

  const clearCampos = () => {
    setInput({
      nick: '',
      pass: '',
      nome: '',
      admin: false,
    });
    setLoading(false);
    setUser(null);
    setError({
      nick: false,
      pass: false,
      nome: false,
      message: '',
    });
  };

  const createUser = async () => {
    try {
      const resp = await Api.post('/user/register', {
        nick: input.nick,
        nome: input.nome,
        senha: input.pass,
      });

      setUser(resp.data);
    } catch {
      setUser(false);
    }
  };

  const handleClick = () => {
    setLoading(true);
    setError({
      nick: !input.nick.length > 0,
      pass: !input.pass.length > 0,
      nome: !input.nome.length > 0,
      message: '',
    });

    try {
      createUser();
    } catch (e) {
      setError((v) => {
        return {
          ...v,
          message: e.message,
        };
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    setInput({
      ...input,
      [name]: value,
    });
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-success"
        data-bs-toggle="modal"
        data-bs-target={`#newusercanhotomodal`}
        onClick={clearCampos}
      >
        Criar novo usuário
      </button>

      <div
        id={`newusercanhotomodal`}
        className="modal fade"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Criação de usuário
              </h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-6">
                  <label className="form-label">Usuário</label>
                  <input
                    name="nick"
                    type="text"
                    className={`form-control ${error.nick ? 'is-invalid' : ''}`}
                    aria-label="Text input with dropdown button"
                    value={input.nick}
                    onChange={handleChange}
                    disabled={user}
                  />
                </div>
                <div className="col-6">
                  <label className="form-label">Senha Inicial</label>
                  <input
                    name="pass"
                    type="password"
                    className={`form-control ${error.pass ? 'is-invalid' : ''}`}
                    aria-label="Text input with dropdown button"
                    value={input.pass}
                    onChange={handleChange}
                    disabled={user}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Nome</label>
                  <input
                    name="nome"
                    type="text"
                    className={`form-control ${error.nome ? 'is-invalid' : ''} mb-3`}
                    aria-label="Text input with dropdown button"
                    value={input.nome}
                    onChange={handleChange}
                    disabled={user}
                  />

                  <div className="form-check">
                    <input
                      name="admin"
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                      checked={input.admin}
                      onClick={() => setInput({ ...input, admin: !input.admin })}
                    />
                    <label className="form-check-label" htmlFor="flexCheckDefault">
                      Acesso admin
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {user ? (
                <div className="alert alert-success w-100" style={{ textAlign: 'center' }} role="alert">
                  Usuário criado com sucesso!
                </div>
              ) : (
                <button type="button" className="btn btn-outline-success" onClick={handleClick}>
                  {loading ? (
                    <div className="spinner-border spinner-border-sm" role="status" style={{ margin: '0 35px' }}>
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    <>Criar Usuário</>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
